"use client";

import Image from "next/image";
import { cn } from "../../lib";
import {
	resolveStopTypeIconSrc,
	type StopTypeIconKind,
} from "../../lib/stop-type-icons";

export type StopTypeIconSize = "xs" | "sm" | "md" | "lg";

const STOP_TYPE_ICON_SIZE_CLASS: Record<
	StopTypeIconSize,
	{ box: string; sizes: string }
> = {
	xs: { box: "size-4", sizes: "16px" },
	sm: { box: "size-[18px]", sizes: "18px" },
	md: { box: "size-7", sizes: "28px" },
	lg: { box: "size-9", sizes: "36px" },
};

export interface StopTypeIconProps {
	type: StopTypeIconKind;
	size?: StopTypeIconSize;
	className?: string;
	imageClassName?: string;
}

export function StopTypeIcon({
	type,
	size = "md",
	className,
	imageClassName,
}: StopTypeIconProps) {
	const preset = STOP_TYPE_ICON_SIZE_CLASS[size];
	const src = resolveStopTypeIconSrc(type);

	if (!src) {
		return null;
	}

	return (
		<span
			className={cn(
				"relative inline-block shrink-0 overflow-visible",
				preset.box,
				className,
			)}
		>
			<Image
				src={src}
				alt=""
				fill
				className={cn("object-contain", imageClassName)}
				sizes={preset.sizes}
				aria-hidden
			/>
		</span>
	);
}
